import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource/montserrat/400.css'
import '@fontsource/montserrat/700.css'
import '@/styles/main.css'
import App from './App.tsx'
import { ThemeWrapper } from './components/ThemeWrapper.tsx'
import { UserLanguageContextProvider } from './contexts/userLanguageContextProvider.tsx'
import { BrowserRouter } from 'react-router'
import { UserDataContextProvider } from './contexts/userDataContextProvider.tsx'
import { ApolloProvider } from '@apollo/client'
import { client } from './graphql/apolloClient.ts'
import { OpeningElementsControllerContextProvider } from './contexts/OpeningElementsControllerContextProvider.tsx'
import { ErrorHandlerProvider } from './contexts/ErrorHandlerContextProvider.tsx'
import { ListNavigationStateContextProvider } from './contexts/ListNavigationStateContextProvider.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeWrapper>
      <BrowserRouter>
        <ApolloProvider client={client}>
          <UserLanguageContextProvider>
            <UserDataContextProvider>
              <OpeningElementsControllerContextProvider>
                <ErrorHandlerProvider>
                  <ListNavigationStateContextProvider>
                    <App />
                  </ListNavigationStateContextProvider>
                </ErrorHandlerProvider>
              </OpeningElementsControllerContextProvider>
            </UserDataContextProvider>
          </UserLanguageContextProvider>
        </ApolloProvider>
      </BrowserRouter>
    </ThemeWrapper>
  </StrictMode>,
)
